import React from "react";
import styles from "./PageContainer.module.css";
import { IoIosArrowBack } from "react-icons/io";
import { RiSearchLine } from "react-icons/ri";
import { FaWarehouse } from "react-icons/fa"; // Icono de almacenamiento
import Redirect from "../../utils/Redirect";
import sterilizationImage from "../../assets/images/ICONO STERILIZATION NEW.svg";
import hygieneMonitoringImage from "../../assets/images/ICONO HYGIENE MONITORING.svg";
import { ToastContainer } from "react-toastify";
import StepProgress from "./StepProgress/StepProgress";
import washingImg from "../../assets/images/WASHING.svg";
import t from "../../utils/translation";
import WashingStepper from "./WashingStepper/WashingStepper";
import SterilizationStepper from "./SterilizationStepper/SterilizationStepper";
import ReportsImage from "../NavBar/Menu/icons/COMPLETED.svg";
import dispatchImage from "../../assets/images/Almacenamiento y despacho.svg"
import receptionImage from "../../assets/images/Recepción de materiales.svg"

export default function PageContainer({
  categoryId,
  category,
  subcategory,
  title,
  subtitle,
  children,
  menu = false,
  backUrl,
  newButton = false,
  newButtonUrl,
  scan = false,
  clickBack = false,
  onClickBack = () => {},
  progress = false,
  currentStep,
  washerLoad = false,
}) {
  const defaultImage =
    categoryId == 1
      ? sterilizationImage
      : categoryId == 2
      ? washingImg
      : String(categoryId).toUpperCase() == "REPORTS"
      ? ReportsImage
      : categoryId == 5 ? receptionImage : categoryId == 4 ? dispatchImage : hygieneMonitoringImage;

  const imageColor =
  categoryId == 5
      ? styles.reception :
    categoryId == 4
      ? styles.dispatch
      : categoryId == 1
      ? styles.sterilization
      : categoryId == 2
      ? styles.washing
      : String(categoryId).toUpperCase() == "REPORTS"
      ? ""
      : styles.hygieneMonitoring;

      const washingSteps = ["WasherLoadings", "WashCycles", "WashRelease"];
      const sterilizationSteps = ["Packages", "Loads", "Cycles", "Release"];
      
      function getCurrentStep(index, categoryId) {
        const steps = categoryId === 1 ? sterilizationSteps : washingSteps;
        const adjustedIndex = (index - 1) % steps.length;
        return steps[adjustedIndex];
      }

  return (
    <div className={styles.pageContainer}>
      <ToastContainer />
      {progress &&
        (categoryId === 1 ? (
          <SterilizationStepper currentStepString={getCurrentStep(currentStep, categoryId)} />
        ) : (
          <WashingStepper currentStepString={getCurrentStep(currentStep, categoryId)} />
        ))}
      <div className={styles.page}>
        <IoIosArrowBack
          className={styles.backIcon}
          onClick={() =>
            clickBack
              ? onClickBack()
              : Redirect({
                  redirect: true,
                  path: backUrl,
                })
          }
        />
        <div className={styles.header}>
          <div className={styles.breadcrumb}>
            
            <div className={`${styles.imageContainer} ${imageColor}`}>
              
                <img src={defaultImage} className={styles.image} alt={category} />
            </div>

            <div className={styles.titlesContainer}>
              <p className={styles.category}>{category}</p>
              <p className={styles.category}>
                {subcategory && `| ${subcategory}`}
              </p>
              <p className={styles.title}>{title && `| ${title}`}</p>
              <p className={styles.title}>{subtitle && `| ${subtitle}`}</p>
            </div>

            {newButton && (
              <button
                className={`${styles.newButton} ${
                  categoryId == 1
                    ? styles.backgroundGreen
                    : categoryId == 2
                    ? styles.backgroundBlue
                    : styles.backgroundPurple
                }`}
                onClick={() =>
                  Redirect({
                    redirect: true,
                    path: newButtonUrl,
                  })
                }
              >
                {t("NewSpanButton")}
              </button>
            )}
          </div>

          {menu && (
            <div className={styles.searchContainer}>
              <RiSearchLine className={styles.searchIcon} />
              <input
                type="text"
                placeholder="Smart search"
                className={styles.searchInput}
              />
            </div>
          )}
        </div>

        {!washerLoad && <div className={styles.content}>{children}</div>}
      </div>
      {washerLoad && <div className={styles.washerLoad}>{children}</div>}
    </div>
  );
}
